export interface TimelineStep {
  time: string;
  text: string;
}

export interface GuaEvent {
  id: number;
  date: string;
  weekday: string;
  category: string;
  title: string;
  tag: string;
  heat: number;
  isHot?: boolean;
  summary: string;
  steps: TimelineStep[];
}

export interface HotTopic {
  id: number;
  title: string;
  category: string;
  views: string;
  summary: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface Testimonial {
  name: string;
  role: string;
  text: string;
}

export const categories = [
  "全部",
  "影视热点",
  "综艺话题",
  "音乐现场",
  "时尚品牌",
  "行业观察",
];

export const timeline: GuaEvent[] = [
  {
    id: 1,
    date: "09-02",
    weekday: "周二",
    category: "影视热点",
    title: "暑期档后首部刑侦剧官宣杀青，主演阵容引爆路透热议",
    tag: "官宣",
    heat: 96,
    isHot: true,
    summary:
      "一部聚焦现代刑侦题材的新剧结束数月拍摄正式杀青，官微放出杀青特辑。选角搭配与场景路透同步流出，围绕角色契合度的讨论持续走高。",
    steps: [
      { time: "上午 10:00", text: "剧组官微发布杀青消息与现场合照，相关词条开始发酵。" },
      { time: "中午 12:30", text: "数位主演同步发文告别角色，路透片段被二次传播。" },
      { time: "晚间 21:00", text: "关于剧情风格与档期预期的讨论登上影视区热榜。" },
      { time: "次日", text: "片方回应档期待定，主线看点预告片进入后期制作。" },
    ],
  },
  {
    id: 2,
    date: "09-03",
    weekday: "周三",
    category: "综艺话题",
    title: "音乐竞演综艺新一季开播，首期舞台改编掀起对比风波",
    tag: "开播",
    heat: 91,
    summary:
      "人气音乐竞演节目新一季正式上线，首期多位选手的改编舞台引发审美讨论。编曲方向与原曲风格的取舍，成为当周热度最高的综艺话题之一。",
    steps: [
      { time: "周五 20:00", text: "节目首期上线，舞台片段播放量快速攀升。" },
      { time: "播出后 2 小时", text: "热门改编舞台登上热搜，评论区形成两派观点。" },
      { time: "次日 上午", text: "节目组释出舞台幕后花絮，编曲团队发声解释改编思路。" },
      { time: "本周末", text: "话题热度回落，官方公布下期嘉宾悬念卡。" },
    ],
  },
  {
    id: 3,
    date: "09-04",
    weekday: "周四",
    category: "音乐现场",
    title: "年度音乐节阵容官宣，压轴名单与票务规则引发解读",
    tag: "阵容",
    heat: 88,
    isHot: true,
    summary:
      "一场跨城联动的大型音乐节正式公布全阵容，压轴艺人安排与购票规则成为焦点。粉丝群体针对演出时长的信息展开多方求证。",
    steps: [
      { time: "11:00", text: "官方分三批放出口碑阵容海报，第一时间引发转发。" },
      { time: "14:30", text: "压轴时段安排被重点解读，主办方评论区涌入提问。" },
      { time: "17:00", text: "票务平台开放预约，票档与退改规则说明同步更新。" },
      { time: "晚间", text: "主办方补充演出时长与分区说明，讨论逐渐平息。" },
    ],
  },
  {
    id: 4,
    date: "09-05",
    weekday: "周五",
    category: "时尚品牌",
    title: "国民护肤品牌换代言人，新旧物料同台引热议",
    tag: "代言",
    heat: 84,
    summary:
      "一个大众熟知的护肤品牌宣布全新代言阵容，新旧宣传物料在同一渠道轮播。关于品牌调性与代言人气质的适配度成为吃瓜热门。",
    steps: [
      { time: "9:30", text: "品牌官微发布新代言官宣海报，替换首页主视觉。" },
      { time: "11:00", text: "旧代言剩余物料被消费者截图讨论，官方回应称属正常更替。" },
      { time: "15:00", text: "代言人粉丝与老粉围绕品牌多年沉淀展开观点交锋。" },
      { time: "次日晚", text: "品牌发布合作理念短片，热点趋于温和。" },
    ],
  },
  {
    id: 5,
    date: "09-06",
    weekday: "周六",
    category: "行业观察",
    title: "头部视频平台调整分账规则，行业解读刷屏从业者群",
    tag: "热点",
    heat: 90,
    isHot: true,
    summary:
      "某头部视频平台公布新一轮内容分账与激励规则，重点倾斜中腰部创作团队。业内人士连夜整理对比，围绕长短剧收益结构的讨论热度高企。",
    steps: [
      { time: "上午", text: "平台官方账号发布新规则长文，要点被快速梳理转发。" },
      { time: "下午", text: "多家从业者机构发布解读，对比旧版测算收益变化。" },
      { time: "晚间", text: "话题登上行业讨论区，长短视频制作方观点分化。" },
      { time: "次日", text: "平台补充答疑，正式实施时间与适用范围被明确。" },
    ],
  },
  {
    id: 6,
    date: "09-07",
    weekday: "周日",
    category: "影视热点",
    title: "老牌 IP 重启版定档，主角人选与原著还原度成焦点",
    tag: "定档",
    heat: 87,
    summary:
      "一部陪伴多代人成长的经典 IP 重启剧正式宣布定档。预告片释出后，围绕选角气质与剧情改动是否忠于原著的话题迅速升温。",
    steps: [
      { time: "12:00", text: "官方发布定档海报与 60 秒预告片。" },
      { time: "14:00", text: "原著粉丝逐帧对比细节，列出还原与改编清单。" },
      { time: "19:00", text: "主演直播回应角色理解，正面回应选角争议。" },
      { time: "周末", text: "超前点映场开启报名，口碑进入首轮观望期。" },
    ],
  },
  {
    id: 7,
    date: "09-08",
    weekday: "周一",
    category: "综艺话题",
    title: "户外慢综收官夜，全员泪点与导演组发言同时刷屏",
    tag: "收官",
    heat: 82,
    summary:
      "一档口碑扎实的户外慢综艺迎来本季收官。收官夜全员走心告别，导演组谈创作初衷的片段被二次传播，成为近期最有温度的热点。",
    steps: [
      { time: "晚 21:30", text: "收官集上线，成员告别画面大量出圈。" },
      { time: "22:40", text: "导演组幕后专访释出，谈节目如何留住真实感。" },
      { time: "次日", text: "网友盘点本季高光时刻，追问下一季嘉宾阵容。" },
      { time: "周内", text: "节目官微放出加更彩蛋，为热度做平稳收尾。" },
    ],
  },
  {
    id: 8,
    date: "09-09",
    weekday: "周二",
    category: "音乐现场",
    title: "音乐人巡演加场公告出现票务口径出入，官方连夜澄清",
    tag: "澄清",
    heat: 93,
    summary:
      "一位高人气音乐人宣布巡演加场后，因部分渠道对可售场次的表述不一致引发购票者疑惑。主办方当晚发布统一说明并协调退改，风波在澄清后快速降温。",
    steps: [
      { time: "上午", text: "官方宣布加开两场，票务平台同步开启预约。" },
      { time: "中午", text: "部分第三方渠道出现场次口径不一，购票群讨论升温。" },
      { time: "晚间 21:00", text: "主办方与演出方联合发布澄清声明，明确可售场次与时间。" },
      { time: "次日", text: "开票顺利进行，围绕口径出入的讨论逐步收束。" },
    ],
  },
  {
    id: 9,
    date: "09-09",
    weekday: "周二",
    category: "行业观察",
    title: "艺人生日直播翻车名场面集锦，从剪辑到再解读一周出圈",
    tag: "热议",
    heat: 79,
    summary:
      "一条收集各路直播突发场面的短视频在社交平台刷屏，从原片段到网友二次创作，完整呈现了直播不可控名场面的演变脉络，兼具笑点与思考。",
    steps: [
      { time: "周一", text: "早期名场面剪辑帖开始获得高曝光。" },
      { time: "周三", text: "多个直播平台出现同类话题，二次创作数量激增。" },
      { time: "周五", text: "从业者参与解读直播团队如何应对突发。" },
      { time: "周末", text: "话题热度回落，成为本月传播曲线完整的吃瓜案例。" },
    ],
  },
];

export const hotTopics: HotTopic[] = [
  {
    id: 1,
    title: "刑侦剧杀青后档期迟迟未定，粉丝与平台博弈进入拉锯",
    category: "影视热点",
    views: "128.6万",
    summary: "从官宣到档期悬置，关于播出节奏与后期投入的猜测始终没有停歇。",
  },
  {
    id: 2,
    title: "音乐竞演综艺改编争议背后，是改编自由还是过度加工",
    category: "综艺话题",
    views: "96.2万",
    summary: "一场关于翻唱边界的讨论，把行业老问题重新摆上台面。",
  },
  {
    id: 3,
    title: "音乐节票务口径风波全还原，一张澄清声明如何平息争议",
    category: "行业观察",
    views: "88.4万",
    summary: "从口径不一到统一澄清，完整复盘一场危机的 24 小时处理路径。",
  },
  {
    id: 4,
    title: "国民品牌换代言，情怀粉与新粉的注意力争夺战",
    category: "时尚品牌",
    views: "73.9万",
    summary: "一个换代言的小事件，折射出老牌焕新的普遍焦虑。",
  },
];

export const faqs: FaqItem[] = [
  {
    q: "本月大瓜时间线是什么？",
    a: "本月大瓜时间线是一个以“时间线”为核心形式的娱乐圈与文娱热点回顾站点。我们不追单一新闻的流量，而是把本月发生的热门事件，按发生顺序逐条整理成脉络，方便你在几分钟内看懂一件大瓜从开始到收尾的完整经过。",
  },
  {
    q: "“大瓜经过”通常会按哪些阶段梳理？",
    a: "一般来说，我们会把一件大瓜的经过划分为几个阶段：事件最初的信息源与爆发点、各方回应与舆论发酵、相关方澄清或补充、再到热度回落与后续影响。每个阶段都会附上大致时间，帮助你建立清晰的前后顺序。",
  },
  {
    q: "时间线上的事件和标题可信吗？",
    a: "本站所有时间线内容都基于公开可查的报道与官方信息梳理而成，并在摘要中尽量标注信息来源的公开属性。我们不制造、不放大未经证实的信息，遇到存在分歧的说法会如实注明“多方说法不一”，供你自行判断。",
  },
  {
    q: "你们和艺人、综艺、影视公司是什么关系？",
    a: "本站是独立的文娱内容梳理与回顾站点，与任何艺人、经纪公司、综艺或影视项目均无商业合作或隶属关系。我们只做公开信息的整理与脉络呈现，观点仅代表编辑部立场。",
  },
  {
    q: "如何快速看懂一件大瓜的全程？",
    a: "推荐先看时间线条目的标题与标签，确认事件性质；随后阅读摘要了解背景，再展开查看“经过节点”来理清先后顺序；若想深入，可参考热度较高的焦点话题与相关分析。这样最快能建立起对一件大瓜的整体认知。",
  },
  {
    q: "我可以投稿或补充某件大瓜的线索吗？",
    a: "当然可以。如果你认为某条时间线信息有缺漏，或发现我们梳理的先后顺序有误，欢迎通过页面底部的联系方式向我们反馈。我们会根据公开信息核实后及时修正，确保脉络尽可能准确完整。",
  },
];

export const testimonials: Testimonial[] = [
  {
    name: "一只追剧的栗子",
    role: "影视观众",
    text: "以前吃瓜全靠刷评论拼时间线，看得一头雾水。现在顺着这里的经过节点从头到尾看一遍，几件大事的前因后果瞬间就通了。",
  },
  {
    name: "阿澈",
    role: "综艺爱好者",
    text: "最喜欢它把“经过”分阶段的梳理方式，谁先发声、谁后来回应、最后怎么收尾，清清楚楚，比我自己翻聊天记录强太多了。",
  },
  {
    name: "Momo酱",
    role: "资讯编辑",
    text: "做选题时候经常来这里对时间线，条理清楚、口径严谨，是很好的参考入口。它不煽风点火，这点我最放心。",
  },
];

export const siteContact = {
  email: "hello@guatimeline.example.com",
  weibo: "本月大瓜时间线",
  slogan: "脉络清晰，吃瓜不迷路",
};